// extracted by mini-css-extract-plugin
export default {"loadingPlaceholder":"jhduVE3jWRsle-EBAXs4Cw=="};